import { getClerkInstance } from "@clerk/clerk-expo";
import { useAppStore } from "@hooks/useAppStore";

/**
 * Auth headers for authenticated hub (`baseNextjsUrl`) requests. Mirrors the
 * app's axios interceptor: a Clerk `jwt-with-user` token in `Authorization`
 * (raw token, no "Bearer " prefix - the hub's auth middleware accepts both)
 * plus the current `tenantid`. Use for any direct `fetch`/`expo/fetch` call to
 * a Clerk-protected hub route.
 */
export const getHubAuthHeaders = async (): Promise<Record<string, string>> => {
	const token = await getClerkInstance().session?.getToken({
		template: "jwt-with-user",
	});
	const tenantId = useAppStore.getState().tenant.id;

	const headers: Record<string, string> = {};
	if (token) {
		headers.Authorization = token;
	}
	if (tenantId) {
		headers.tenantid = String(tenantId);
	}
	return headers;
};
